import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vue3TouchEvents from 'vue3-touch-events'
import audio from 'vue-mobile-audio'
// import VueJsonp from 'vue-jsonp'
import {
  Search,
  Button,
  Icon,
  Popup,
  DatetimePicker,
  DropdownMenu,
  DropdownItem,
  Collapse,
  CollapseItem,
  Swipe,
  SwipeItem,
  Grid,
  GridItem,
  Calendar
} from 'vant'
import 'lib-flexible/flexible'
import 'normalize.css'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import './style/index.scss'

createApp(App)
  .use(store)
  .use(router)
  .use(Vue3TouchEvents)
  .use(audio)
  .use(Antd)
  .use(Search)
  .use(Button)
  .use(Icon)
  .use(Popup)
  .use(DatetimePicker)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Collapse)
  .use(CollapseItem)
  .use(Swipe)
  .use(SwipeItem)
  .use(Grid)
  .use(GridItem)
  .use(Calendar)
  .mount('#app')
